<template>
<div class="invitetenants">
  <img src="@/assets/images/inviteowns01.png" class="topimg"/>
  <div class="cont">
     <div class="tit">奖励说明</div>
     <p>1. 邀请租客完成首笔订单，邀请人可获得返现奖励；</p>
     <p>2. 奖励金额发放至“个人钱包”，可按照平台提现规则提现；</p>
     <p>3. 奖励规则如下</p>
     <img src="@/assets/images/inviteowns02.png" alt="">
  </div>
  <div class="btn">
    <button @click="openShare()">去邀请</button>
  </div>
  <div class="share" v-if="showShare">
    <div class="mask" @click="closeShare()"></div>
    <div class="content">
      <div class="title">邀请方式</div>
      <div class="bar">
         <div class="item" v-if="false" ><!-- deviceType == 3 -->
          <img class="ico" @click="share" src="@/assets/images/share1.png"/>
          <div class="txt">微信好友</div>
          <button class="btn" type="default" open-type="share"></button>
        </div>
        <div class="item" v-clipboard:copy="configureInfo.href" v-clipboard:success="onCopy">
          <img class="ico" src="@/assets/images/share2.png"/>
          <div class="txt">链接邀请</div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
// import { orderSource } from "@/utils/env";
export default {
  name: "invitetenants",
  data() {
    return {
      showShare: false,
      name:'',
      userid:'',
      configureInfo:{
        href:''
      }
    };
  },
  props: [],
  created(){
    this.init();
  },
  methods: {
    init(){
      let userInfo = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : "";
      if( userInfo ){
        if(userInfo.Name!=''){
          this.name = userInfo.Name
        }else{
          this.name = userInfo.Telephone
        }
      }
      this.userid = userInfo.UserID;
      // console.log(this.name);
      // this.configureInfo.href='http://192.168.0.201:5029/#/jointenants?name='+this.name+'&userID='+this.userid
      this.configureInfo.href='https://apph5.dafang24.com/#/jointenants?name='+this.name+'&userID='+this.userid
    },
    openShare() {
      this.showShare = true;
    },
    closeShare() {
      this.showShare = false;
    },
    onCopy(){
      this.flexible.showToast({
        content:'复制链接成功，分享给微信好友吧！',
        duration:2000,
        success:()=>{
          this.showShare = false;
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped type="text/scss">
.invitetenants {
  width: 100%;
  position: absolute;
  top:0;
  background:#fff;
  .topimg{
    width:100%;
  }
  .cont{
    width:686px;
    margin:0 auto;
    line-height: 45px;
    .tit{
      text-align: center;
    }
    img{
      width:100%;
    }
  }
  .btn{
    margin-top:47px;
    width:750px;
    height: 120px;
    box-shadow:0px -10px 20px rgba(0,0,0,0.06);
    background:#fff;
    display: flex;
    justify-content: center;
    align-items: center;
    button{
      width:600px;
      height: 90px;
      line-height: 90px;
      text-align: center;
      background: #FF8307;
      border-radius: 45px;
      color:#fff;
      font-size: 32px;
      border: none;
      outline: none;
    }
  }
    .share {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    .mask {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: #000;
      opacity: 0.7;
    }
    .content {
      position: absolute;
      left: 0;
      bottom: 0;
      padding: 30px 0;
      box-sizing: border-box;
      width: 100%;
      background: #fff;
      text-align: center;
      .title {
        font-size: 32px;
      }
      .bar {
        padding: 20px 100px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        .item {
          position: relative;
          margin-right: 30px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .ico {
            width: 90px;
            height: 90px;
          }
          .txt {
            margin-top: 15px;
            color: #121212;
            font-size: 24px;
          }
          .btn {
            position: absolute;
            left: 0;
            top: 30px;
            width: 90px;
            height: 140px;
            opacity: 0;
          }
        }
      }
    }
  }

}
</style>

